/**
 * QrSvg.ts - a QR code as a self-contained SVG string, for the share popover
 * (BridgeViewer's CloudBar). One <path> of unit squares, so it scales crisply
 * to whatever box the page gives it, and a quiet zone of 4 modules, which
 * phone cameras need to find the code at all.
 */
import qrcode from 'qrcode-generator';

export function qrSvg(text: string, dark = '#111111', light = '#ffffff'): string {
  // M (15%) survives a smudged screen; the text is a short URL, so the code stays small.
  const qr = qrcode(0, 'M');
  qr.addData(text, 'Byte');
  qr.make();

  const n = qr.getModuleCount();
  const quiet = 4;
  const size = n + quiet * 2;
  let d = '';
  for (let r = 0; r < n; r++) {
    for (let c = 0; c < n; c++) {
      if (!qr.isDark(r, c)) continue;
      // Run-length along the row: one rectangle per run, not per module.
      let run = 1;
      while (c + run < n && qr.isDark(r, c + run)) run++;
      d += `M${c + quiet} ${r + quiet}h${run}v1h-${run}z`;
      c += run - 1;
    }
  }
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${size} ${size}" shape-rendering="crispEdges" role="img" aria-label="QR code">`
    + `<rect width="${size}" height="${size}" fill="${light}"/><path d="${d}" fill="${dark}"/></svg>`;
}
